// extracted by mini-css-extract-plugin
export default {"page-section__wrapper":"_5D2gDKla","page-section":"_5D3c2Bci"};